<template>
  <div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { store } from '@/plugins/store';
import { AUTHENTICATION } from '@/store/mutation-types';
import { MENU } from '@/components/layout/store/mutation-types';
import { MENU_FOURNISSEUR, MENU_FOURNISSEUR_SWITCH_CLIENT } from '@/components/layout/store/state';

export default defineComponent({
    name: 'ChoixPortailFournisseur',
    beforeMount() {
        store.commit(`authenticationState/${AUTHENTICATION.SET_PORTAIL}`, 'Fournisseur');
        if (localStorage.getItem('isFournisseur') === 'true' && localStorage.getItem('isClient') === 'true') {
            store.commit(`menuState/${MENU.SET_MENU}`, MENU_FOURNISSEUR_SWITCH_CLIENT);
        } else {
            store.commit(`menuState/${MENU.SET_MENU}`, MENU_FOURNISSEUR);
        }
        store.commit(`menuState/${MENU.SET_CHOIX_MENU}`, 'fournisseur');
        this.$router.push('/dashboard-fournisseur');
    }
});
</script>

<style scoped>

</style>
